import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Injectable({ providedIn: 'root' })
export class IdleService {

  private timeout: any;
  private idleTime = 30 * 60 * 1000; // 30 minutes

  constructor(private router: Router, private ngZone: NgZone) {}

  startWatching() {
    this.resetTimer();

    window.addEventListener('mousemove', () => this.resetTimer());
    window.addEventListener('keydown', () => this.resetTimer());
    window.addEventListener('click', () => this.resetTimer());
    window.addEventListener('scroll', () => this.resetTimer());
  }

  resetTimer() {
    clearTimeout(this.timeout);

    this.ngZone.runOutsideAngular(() => {
      this.timeout = setTimeout(() => {
        this.ngZone.run(() => {
          this.logoutUser();
        });
      }, this.idleTime);
    });
  }

  stopWatching() {
    clearTimeout(this.timeout);
  }

private logoutUser() {

  Swal.fire({
    icon: 'warning',
    title: 'Session Timeout',
    text: 'You have been inactive for 20 minutes.',
    confirmButtonText: 'Login Again',
    confirmButtonColor: '#d33',
    allowOutsideClick: false,
    allowEscapeKey: false
  }).then((result) => {
    if (result.isConfirmed) {
      sessionStorage.clear();
      this.router.navigate(['/login']);
    }
  });
}
}